import { render } from "./NewTask.vue?vue&type=template&id=4edacf27&ts=true"
import script from "./NewTask.vue?vue&type=script&lang=ts"
export * from "./NewTask.vue?vue&type=script&lang=ts"

import "./NewTask.vue?vue&type=style&index=0&id=4edacf27&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__